import { withTranslation } from '@application/i18n/with_translation';
import { Button, Flex, IconButton, Text, DropdownMenu, useBreakpoint, BreakPoints } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import styled from 'styled-components';
import { useResolve } from '@visiba/instantiation';
import { RouterService } from '@cortex-shim/router.service';
import { useWindowSize } from '@visiba/react-std';

const elements = {
	container: styled.div`
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: ${tokens.spacing.x2};
		height: 56px;
		background-color: ${tokens.color.bg.surface};
		border-bottom: 1px solid ${tokens.color.border.muted};
		word-wrap: break-word;
		word-break: break-all;
		gap: ${tokens.spacing.x2};

		.side-section {
			flex-shrink: 0;
			min-width: 140px;

			* {
				word-break: keep-all;
				white-space: nowrap;
				flex-shrink: 0;
			}
		}

		&[data-extra-small-screen] {
			padding-left: ${tokens.spacing.x1};

			.side-section {
				min-width: 24px;
			}
		}
	`,
};

interface Props {
	to?: string;
	title?: string;
	analyticAction: string;
	actions?: { label: string; onSelect: () => void }[];
}

export function ViewNavBar({ to, analyticAction, title, actions }: Props): JSX.Element {
	const routerService = useResolve(RouterService);
	const analytic = useAnalyticContext();
	const { width: windowWidth } = useWindowSize();
	const isExtraSmallScreen = windowWidth && windowWidth < 440;
	const isMobile = useBreakpoint(BreakPoints.Small);

	function handleBackClick() {
		if (!to) {
			return;
		}

		analytic.trackEvent(analyticAction);
		routerService.navigateByUrl(to);
	}

	return (
		<elements.container data-extra-small-screen={isExtraSmallScreen || undefined}>
			<Flex align='start' className='side-section'>
				{to != null ? (
					<>
						{isMobile ? (
							isExtraSmallScreen ? (
								<IconButton
									variant='interactive'
									size='small'
									icon='arrowLeft'
									onClick={handleBackClick}
									text={withTranslation('PW.Component.Visits.Title')}
								/>
							) : (
								<Button variant='ghost' size='xSmall' icon='arrowLeft' onClick={handleBackClick}>
									{withTranslation('PW.Component.Visits.Title')}
								</Button>
							)
						) : null}
					</>
				) : null}
			</Flex>
			<Flex grow={1}>
				<Text
					variant='labelSmallRegular'
					style={{
						color: tokens.color.content.muted,
						textAlign: 'center',
					}}
				>
					{title}
				</Text>
			</Flex>
			<Flex align='end' className='side-section'>
				{actions ? (
					<DropdownMenu.Root
						trigger={
							<IconButton
								icon='ellipsisVertical'
								size='small'
								text={withTranslation('PW.Component.Visits.MessagingInfo.MenuTooltip')}
								variant='interactive'
							/>
						}
					>
						{actions.map((action) => (
							<DropdownMenu.Item key={action.label} onSelect={action.onSelect}>
								{action.label}
							</DropdownMenu.Item>
						))}
					</DropdownMenu.Root>
				) : (
					<div />
				)}
			</Flex>
		</elements.container>
	);
}
